import { render, staticRenderFns } from "./comTitle.vue?vue&type=template&id=64b11d08&scoped=true"
import script from "./comTitle.vue?vue&type=script&lang=js"
export * from "./comTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b11d08",
  null
  
)

export default component.exports